module.exports = __webpack_public_path__ + "static/img/pay-4.96ec9f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/pay-4.png
// module id = grkS
// module chunks = 1